import { TaxBillSheetDto } from "src/dtos/taxBill/taxBillSheetDto";
import { formatDate } from "src/utils/string/stringUtil";

// SAL2080_R01은 TaxBillSheetDto를 상속받아 확장
export interface SAL2080_R01Dto extends TaxBillSheetDto {
    // 추가 필드가 필요한 경우 여기에 정의
    // 현재는 TaxBillSheetDto의 모든 필드를 그대로 사용
}

/**
 * 세금계산서 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultSAL2080_R01Data: SAL2080_R01Dto = {
    
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,

    // TaxBillSheetDto 필드들
    taxBillNo: "",
    taxType: "",
    compCd: "",
    customCd: "",
    issuedDt: formatDate(new Date()),
    taxBillCreate: "",
    vatType: "",
    vatRate: 0,
    netAmt: 0,
    moneyCd: "",
    exchangeRate: 0,
    vatIncludeFlag: "",
    billAmt: 0,
    vatAmt: 0,
    taxEmpNo: "",
    dtlDt: formatDate(new Date()),
    dtlItemNm: "",
    dtlItemSpec: "",
    dtlItemQty: 0,
    dtlItemCost: 0,
    dtlItemAmt: 0,
    fixedFlag: "",
    inoutAutoFlag: "",
    ntsApproveNo: "",
    remark: "",

    // 상태 필드들
    inserted: false,
    isModified: false
};
